import React from 'react';
import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { createMuiTheme } from '@material-ui/core/styles';
import Grid from "@material-ui/core/Grid";
import CardCreditCard from "./CardCreditCard";
import PropertyManagerTowForm from "./PropertyManagerTowForm";
import GridList from "@material-ui/core/GridList";
import CardCompanyPropertyInformation from "./CardCompanyPropertyInformation";
import CardTowJobInformation from "./CardTowJobInformation";
import CardFullTowJobInformation from "./CardFullTowJobInformation";
import SearchIcon from '@material-ui/icons/Search';
import FindReplaceIcon from '@material-ui/icons/FindReplace';

import ParkingTextVehicleOwner from "./ParkingTextVehicleOwner";
import TextTowAgent from "./TextTowAgent";
import {DEFAULT_VESPAAN_SERVER, websocket_towjob, websocket_towjob_delete} from "../../utils/MainConstants";
import ShowPictures from "./ShowPictures";





import {bindActionCreators} from "redux";
import { Document, Page } from 'react-pdf';

import samplePDF from '../../images/79MJ45.pdf';

//import PDF from "react-pdf-js";

//import {ReactPDF} from 'react-pdf';
//import { Document } from 'react-pdf/dist/entry.webpack';

import { setOptions, pdfjs } from 'react-pdf';

//import 'react-pdf/dist/Page/AnnotationLayer.css';



import {
    deleteACompanyproperty,
    loadCompanypropertysData,
    saveACompanyproperty, updateACompanyproperty
} from "../../redux/modules/companyproperty";
import {loadCompanysData} from "../../redux/modules/company";
/*import { loadTowjobsData, deleteATowjob,  saveATowjob,  updateATowjob,loadTowjobsDataWithFilter,
    setTowStatusFilter,
    setTowVinFilter,
    setTowPlateFilter,
    setTowStartTimeFilter,
    setTowEndTimeFilter,
    setTowModelFilter,
    setTowMakeFilter,
    setTowColorFilter,
    setTowYearFilter,
    clearTowAllFilters} from "../../redux/modules/towjob";*/


import { loadParkingIncidentsData, deleteATowjob,  saveAParkingIncident,  updateATowjob,loadParkingIncidentsDataWithFilter,
    setParkingIncidentStatusFilter,
    setParkingIncidentVinFilter,
    setParkingIncidentPlateFilter,
    setParkingIncidentStartTimeFilter,
    setParkingIncidentEndTimeFilter,
    setParkingIncidentModelFilter,
    setParkingIncidentMakeFilter,
    setParkingIncidentColorFilter,
    setParkingIncidentYearFilter,
    clearParkingIncidentAllFilters} from "../../redux/modules/parkingincident";



import {connect} from "react-redux";
import ExpandableTowJobInformation from "./ExpandableTowJobInformation";
import PropTypes from "prop-types";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/core/SvgIcon/SvgIcon";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import DialogContentText from "@material-ui/core/DialogContentText";
import Draggable from "react-draggable";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import MenuItem from "@material-ui/core/MenuItem";
//import {MuiPickersUtilsProvider, TimePicker} from "material-ui-pickers";
import DateFnsUtils from "@date-io/date-fns";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
//import {KeyboardDateTimePicker} from "@material-ui/pickers";

//import { TimePicker, DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { TimePicker,DatePicker, DateTimePicker, KeyboardDateTimePicker ,MuiPickersUtilsProvider} from "@material-ui/pickers";

//import { TimePicker,DatePicker, DateTimePicker, KeyboardDateTimePicker ,MuiPickersUtilsProvider} from "@material-ui/pickers";
import * as SockJS from "sockjs-client";
import * as Stomp from "stomp-websocket";
//import {loadParkingIncidentsData} from "../../redux/modules/parkingincident";

//import {ReactPDF} from "react-pdf";


//pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

/*setOptions({
    workerSrc: '/js/pdf.worker.js',
});


setOptions({
    workerSrc: '/pdf.worker.entry.js',
});*/


const useStyles = theme => ({
    root: {
        width: '100%',
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
});


const styles = theme => ({
    main: {
        width: 'auto',
        display: 'block', // Fix IE 11 issue.
        marginLeft: theme.spacing.unit * 3,
        marginRight: theme.spacing.unit * 3,
        [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
            width: 800,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing.unit * 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
    },
    avatar: {
        margin: theme.spacing.unit,
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing.unit,
    },
    submit: {
        marginTop: theme.spacing.unit * 3,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        //backgroundColor:"#e2580d",
        backgroundColor:"#b1e4f2",
        color:"black",
        textTransform: "unset !important",
    },
    gridList: {
        width: '100%',
        height: '100%',
        maxHeight:800,
        //maxHeight:'100',
    },
    dividerColor: {
        //marginTop: theme.spacing.unit * 3,
        color:"#7b32a8",
        backgroundColor:"#7b32a8",
    },
    purplebutton: {
        marginTop: theme.spacing.unit * 3,
        marginLeft: theme.spacing.unit,
        backgroundColor:"#8a4e8a",
        color:"white",
        textTransform: "unset !important",
    },
    root: {
        width: '100%',
        maxWidth: 4000,
        backgroundColor: theme.palette.background.paper,
    },

});

function PaperComponent(props) {
    return (
        <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
    </Draggable>
);
}


class PropertyManagerTowInfo extends React.Component {

    state = {
        open: true,
        selectedItem: 'Tows',
        anchorEl: null,
        selectedCompanyInHere : "",
        passingTowJob:{},
        editMode:true,
        numPages: null,
        pageNumber: 1,
        vehicleOwnerMode:false,
        towAgentMode:false,
        showPictureMode:false,
        parkingincidentsArray:null,
        year:"",
        make:"",
        color:"",
        vin:"",
        platenumber:"",
        model:"",
        dispatchEndTime:null,
        dispatchStartTime:null,
        filterStatus:"Active",
        filterIsOn:false,
        showEditScreen:true,
    };

    //const [open, setOpen] = React.useState(false);

    constructor(props) {
        super(props);
        this.parkingIncidentCardList=null;
        this.stompClient = null;
        this.editRecord = this.editRecord.bind(this);
        this.deleteRecord = this.deleteRecord.bind(this);
        this.getListOfTowJobs = this.getListOfTowJobs.bind(this);
        //this.handleCompanyChange=this.handleCompanyChange.bind(this);
        this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
        this.handlePrevious = this.handlePrevious.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.onDocumentComplete = this.onDocumentComplete.bind(this);
        this.vehicleOwnerTextMode = this.vehicleOwnerTextMode.bind(this);
        this.towAgentTextMode = this.towAgentTextMode.bind(this);
        this.loadParkingIncidentData = this.loadParkingIncidentData.bind(this);
        this.handleClickShowEmailSelectClose = this.handleClickShowEmailSelectClose.bind(this);
        this.handleClickShowEmailSelect = this.handleClickShowEmailSelect.bind(this);
    
        this.handlePlatenumberChange = this.handlePlatenumberChange.bind(this);
        this.handleVinChange = this.handleVinChange.bind(this);
        this.handleModelChange = this.handleModelChange.bind(this);
        this.handleMakeChange = this.handleMakeChange.bind(this);
        this.handleColorChange = this.handleColorChange.bind(this);
        this.handleYearChange = this.handleYearChange.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.getListOfStatusForSelection = this.getListOfStatusForSelection.bind(this);
        this.handleFilterStatusChange = this.handleFilterStatusChange.bind(this);
        this.handleDispatchEndTimeChange = this.handleDispatchEndTimeChange.bind(this);
        this.handleDispatchStartTimeChange = this.handleDispatchStartTimeChange.bind(this);
        this.clearFilters = this.clearFilters.bind(this);
        this.isThereAFilter = this.isThereAFilter.bind(this);
        this.handleLast24Hours = this.handleLast24Hours.bind(this);
        this.refresh = this.refresh.bind(this);
        this.HideOrShowList = this.HideOrShowList.bind(this);
        this.showPicturesMode = this.showPicturesMode.bind(this);
        
       
    
        
    
        
        
        
        
    }



    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
    
    HideOrShowList(){
        if(this.state.showEditScreen == false) {
            this.setState({showEditScreen: true});
        }else{
            this.setState({showEditScreen: false});
        }
    }

    editRecord(singleRowData){
        /* let tempPeopleArray=[];
         this.setState({inputFieldShrinkState:true});
         this.setState({selectedProperty:singleRowData });
         this.setState({selectedState: singleRowData.state});
         this.setState({selectedCountry: singleRowData.country});
         if(singleRowData.authorizedpeople != null) {
             tempPeopleArray = JSON.parse(singleRowData.authorizedpeople);
         }

         this.setState({selectedListOfAuthorizedPeople:tempPeopleArray});
         */
        //console.log("I got the object " + singleRowData.toString());
        this.setState({passingTowJob :singleRowData });
        /*if(this.state.editMode) {
            this.setState({editMode: false});
        }else{
            this.setState({editMode: true});
        }*/
        this.setState({showPictureMode: false});
        this.setState({vehicleOwnerMode: false});
        this.setState({editMode: true});
        this.setState({towAgentMode: false});
        this.setState({showEditScreen:true});

    }

    vehicleOwnerTextMode(singleRowData){

        //console.log("I got the object " + singleRowData.toString());
        this.setState({passingTowJob :singleRowData });
        /*if(this.state.vehicleOwnerMode) {
            this.setState({vehicleOwnerMode: false});
        }else{
            this.setState({vehicleOwnerMode: true});
        }*/
        this.setState({showPictureMode: false});
        this.setState({vehicleOwnerMode: true});
        this.setState({editMode: false});
        this.setState({towAgentMode: false});
        this.setState({showEditScreen:true});


    }
    
    showPicturesMode(singleRowData){
        
        //console.log("I got the object " + singleRowData.toString());
        this.setState({passingTowJob :singleRowData });
        /*if(this.state.vehicleOwnerMode) {
            this.setState({vehicleOwnerMode: false});
        }else{
            this.setState({vehicleOwnerMode: true});
        }*/
        this.setState({showPictureMode: true});
        this.setState({vehicleOwnerMode: false});
        this.setState({editMode: false});
        this.setState({towAgentMode: false});
        this.setState({showEditScreen:true});
        
        
    }
    
    
    clearFilters(){
        let { clearTowAllFilters } = this.props;
        /*this.setState({vin:"", platenumber:"", model:"", year:"",color:"", dispatchStartTime:null,  make:"",
            filterStatus:"", dispatchEndTime:null });
        this.setState({vin:""});*/
    
        clearTowAllFilters();
    }
    
    
    towAgentTextMode(singleRowData){

        //console.log("I got the object " + singleRowData.toString());
        this.setState({passingTowJob :singleRowData });
        /*if(this.state.towAgentMode) {
            this.setState({towAgentMode: false});
        }else{
            this.setState({towAgentMode: true});
        }*/
        this.setState({showPictureMode: false});
        this.setState({vehicleOwnerMode: false});
        this.setState({editMode: false});
        this.setState({towAgentMode: true});
        this.setState({showEditScreen:true});


    }


    onDocumentComplete(pages) {
        this.setState({ page: 1, pages });
    }

    handlePrevious() {
        this.setState({ page: this.state.page - 1 });
    }

    handleNext() {
        this.setState({ page: this.state.page + 1 });
    }

    renderPagination() {
        return (
            <div>
            <button onClick={this.handlePrevious}>&lt;</button>
            <button onClick={this.handleNext}>&gt;</button>
            </div>
    );
    }

    deleteRecord(argProcessId){
        /*
       let { deleteACompanyProperty } = this.props;
       deleteACompanyProperty(DEFAULT_VESPAAN_SERVER.url,argProcessId  );
       */
    }
    
    getListOfStatusForSelection() {
        //let tempArray = this.props.policeArray;
        let returnArray=[];
        returnArray.push(<MenuItem key={'blank'} value={""}>  </MenuItem>);
        returnArray.push(<MenuItem key={'active'} value={"Active"}> Active </MenuItem>);
        returnArray.push(<MenuItem key={'waiting'} value={"Waiting"}>Waiting </MenuItem>);
        returnArray.push(<MenuItem key={'completed'} value={"Completed"}>Completed</MenuItem>);
        
        return(returnArray);
    }
    
    getListOfTowJobsOldOne() {
        let tempArray = this.props.parkingincidentsArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s) => {
                s.editMode=false;
                 if(this.state.editMode == true){
                 return(

                     <CardTowJobInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardTowJobInformation>

                 );
                 }else{
                return(<CardFullTowJobInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardFullTowJobInformation> );
                }
            });
        }
        return(returnArray);
    }


    getListOfTowJobs() {
        let tempArray = this.state.parkingincidentsArray; //this.props.parkingincidentsArray;
        let returnArray=[];
        if (tempArray) {
            returnArray = tempArray.map((s, index) => {
                s.editMode=false;
                let backgroundColorTemp = '#F7FAFA';
                let tempNumber = index%2;
                if(tempNumber ===0){
                    backgroundColorTemp = '#E8F4F9'; //#E7F6FA
                }
                
                   /* return(

                        <CardTowJobInformation info={s}  onEdit={this.editRecord}  onDelete={this.deleteRecord}></CardTowJobInformation>
                     );
            });*/
            return(
              <div style={{width:'100%', height:'100%'}}>
              <ExpandableTowJobInformation info={s} backgroundColor={backgroundColorTemp} key={s.id} onEdit={this.editRecord}  onShowPictures={this.showPicturesMode } onVehicleOwnerText={this.vehicleOwnerTextMode}  onTowAgentText={this.towAgentTextMode}  onDelete={this.deleteRecord}></ExpandableTowJobInformation>
              </div>);
        });
        //Duplicating array for testing only.
        //returnArray = returnArray.concat(returnArray);

        }
        return(returnArray);
    }
    
    
    
    componentWillMount(){
        let { loadTowjobsData } = this.props;
        //loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere );
        //Feb-28-2021 loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany.id );
        //loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, "2b10cbdb-999d-4b4c-9939-b9ca79fc47b5" );
        //loadLocationsData("http://localhost:9065/" );
        this.applyFilters();
        
        this.setState({
            errorCMsg:{}
        });
        
    }

    loadParkingIncidentData(){
        let { loadParkingIncidentsData } = this.props;
        //loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere );
        // delet later loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany );
        loadParkingIncidentsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany );

        this.setState({
            errorCMsg:{}
        });


    }

    componentWillReceiveProps(nextProps) {
        let { loadParkingIncidentsData } = this.props;
    
        if (this.props.selectedCompany != nextProps.selectedCompany) {
        
            //loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, nextProps.selectedCompany);
            this.applyFilters();
            this.setState({
                selectedCompanyInHere: nextProps.selectedCompany
            });
        
        }
        if (this.props.companysArray != nextProps.companysArray) {
            this.setState({
                companysArray: nextProps.companysArray
            });
            
        }


            this.setState({
                parkingincidentsArray: nextProps.parkingincidentsArray
            });
       
    
        this.setState({filterIsOn :this.isThereAFilter()});

    }

    /* 4_22_2020
     handleCompanyChange(argComapnyId){
        let { loadTowjobsData } = this.props;
        this.setState({selectedCompanyInHere:argComapnyId});
        loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, argComapnyId );
    }
        */
    
    isThereAFilter() {
        var returnBool=false;
        if((this.props.towVinFilter.length != 0) ||
            (this.props.towYearFilter.length != 0) ||
            (this.props.towColorFilter.length != 0) ||
            (this.props.towMakeFilter.length != 0) ||
            (this.props.towPlateFilter.length != 0) ||
            (this.props.towModelFilter.length != 0) ||
            (this.props.towStartTimeFilter!= 0)||
            (this.props.towStatusFilter.length!= 0)||
            (this.props.towEndTimeFilter!= 0) ) {
            returnBool=true;
        }
        returnBool;
    
    }
    
    applyFilters() {
      let { loadParkingIncidentsDataWithFilter } = this.props;
         let filter="";
        if((this.props.towVinFilter.length != 0) ||
            (this.props.towYearFilter.length != 0) ||
            (this.props.towColorFilter.length != 0) ||
            (this.props.towMakeFilter.length != 0) ||
            (this.props.towPlateFilter.length != 0) ||
            (this.props.towModelFilter.length != 0) ||
            (this.props.towStartTimeFilter!= 0)||
            (this.props.towStatusFilter.length!= 0)||
            (this.props.towEndTimeFilter!= 0) ) {
            filter="?";
        }
    
        if((this.props.towVinFilter.length != 0)   ) {
            filter=filter+"vehiclevin="+this.props.towVinFilter+"&";
        }
    
        if((this.props.towYearFilter.length != 0)   ) {
            filter=filter+"vehicleyear="+this.props.towYearFilter+"&";
        }
    
        if((this.props.towColorFilter.length != 0)   ) {
            filter=filter+"vehiclecolor="+this.props.towColorFilter+"&";
        }
    
        if((this.props.towModelFilter.length != 0)   ) {
            filter=filter+"vehiclemodel="+this.props.towModelFilter+"&";
        }
    
        if((this.props.towMakeFilter.length != 0)   ) {
            filter=filter+"vehiclemake="+this.props.towMakeFilter+"&";
        }
    
        if((this.props.towPlateFilter.length != 0)   ) {
            filter=filter+"vehicleplatenumber="+this.props.towPlateFilter+"&";
        }
    
        if((this.props.towStatusFilter.length != 0)   ) {
            filter=filter+"status="+this.props.towStatusFilter+"&";
        }
    
        if((this.props.towEndTimeFilter != null)   ) {
            var jsonEndTime = JSON.stringify(this.props.towEndTimeFilter);
            //var jsonEndTime =  this.props.towEndTimeFilter ;
            filter=filter+"endtime="+jsonEndTime+"&";
        }
    
        if((this.props.towStartTimeFilter != null)   ) {
            var jsonStartTime = JSON.stringify(this.props.towStartTimeFilter);
            //var jsonStartTime =  this.props.towStartTimeFilter;
            filter=filter+"starttime="+ jsonStartTime+"&";
            //filter=filter+"starttime="+ this.state.dispatchStartTime+"&";
        }
        //let filter= "?vehicleyear=2007&";
        //loadTowjobsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere,filter  );
        //delete later loadTowjobsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany,filter  );
        loadParkingIncidentsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany,filter  );
        
        //this.props.selectedCompany
        this.handleClickShowEmailSelectClose(false);
    
    }
    
    handleClickShowEmailSelectClose(argKeepDefaultWaiting) {
        let { clearTowAllFilters, setTowStatusFilter } = this.props;
        if(argKeepDefaultWaiting == true) {
            setTowStatusFilter("Waiting");
        }else {
        
        }
        //clearTowAllFilters();
        this.setState({showEmailSelectDialog:false});
    };
    
    handleClickShowEmailSelect() {
        
        this.setState({showEmailSelectDialog:true});
        
    };
    handlePlatenumberChange(event) {
        //event.preventDefault();
        let { setTowPlateFilter } = this.props;
        setTowPlateFilter(event.target.value);
        
        //this.setState({platenumber:event.target.value});
    }
    handleVinChange(event) {
        //event.preventDefault();
        let { setTowVinFilter } = this.props;
        setTowVinFilter(event.target.value);
        //this.setState({vin:event.target.value});
    }
    handleModelChange(event) {
        //event.preventDefault();
        let { setTowModelFilter } = this.props;
        setTowModelFilter(event.target.value);
        //this.setState({model:event.target.value});
    }
    handleMakeChange(event) {
        //event.preventDefault();
        let { setTowMakeFilter } = this.props;
        setTowMakeFilter(event.target.value);
        //this.setState({make:event.target.value});
    }
    handleColorChange(event) {
        //event.preventDefault();
        let { setTowColorFilter } = this.props;
        setTowColorFilter(event.target.value);
        //this.setState({color:event.target.value});
    }
    handleYearChange(event) {
        //event.preventDefault();
        let { setTowYearFilter } = this.props;
        setTowYearFilter(event.target.value);
        //this.setState({year:event.target.value});
    }
    
    refresh(){
        //let { loadTowjobsDataWithFilter } = this.props;
        //loadTowjobsData(DEFAULT_VESPAAN_SERVER.url, this.props.selectedCompany.id );
        //loadTowjobsDataWithFilter(DEFAULT_VESPAAN_SERVER.url, this.state.selectedCompanyInHere,filter  );
        this.applyFilters();
        this.setState({
            errorCMsg:{}
        });
    }
    
    renderFilterCheckBoxes(){
        const {classes} = this.props;
        this.statusSelectList = this.getListOfStatusForSelection();
        
        return(
            <div>
            <Grid container >
    
        <Grid item xs={12} sm={12}>
            <Divider className={classes.dividerColor}></Divider>
            </Grid>
            <Grid item xs={6} sm={6}>
        <TextField id="IDPlateNumber" name="PlateNumber" label="Plate Number" fullWidth InputLabelProps={{ shrink: true }}   value={this.props.towPlateFilter} onChange={this.handlePlatenumberChange}   />
        </Grid>
        <Grid item xs={6} sm={6}>
        <TextField id="IDVIN" name="VIN" label="VIN" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.towVinFilter} onChange={this.handleVinChange}   />
        </Grid>
        <Grid item xs={6} sm={6}>
        <TextField id="IDModel" name="Model" label="Model" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.towModelFilter} onChange={this.handleModelChange}  />
        </Grid>
        <Grid item xs={6} sm={6}>
        <TextField id="IDMake" name="Make" label="Make" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.towMakeFilter} onChange={this.handleMakeChange}   />
        </Grid>
        <Grid item xs={6} sm={6}>
        <TextField id="IDColor" name="Color" label="Color" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.towColorFilter} onChange={this.handleColorChange}   />
        </Grid>
        <Grid item xs={6} sm={6}>
        <TextField id="IDYear" name="Year" label="Year" fullWidth InputLabelProps={{ shrink: true }}  value={this.props.towYearFilter} onChange={this.handleYearChange}   />
        </Grid>
        <Grid item xs={6} sm={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDateTimePicker
                  value={this.props.towStartTimeFilter}
                  onChange={this.handleDispatchStartTimeChange}
                  label="Created Start Date"
                  
                  format="yyyy/MM/dd hh:mm a"
                />
            </MuiPickersUtilsProvider>
            {/*
            <MuiPickersUtilsProvider  utils={DateFnsUtils} >
            <TimePicker
        margin="normal"
        id="time-picker"
        label="Dispatch Start Time"
        value={this.state.dispatchStartTime}
        onChange={this.handleDispatchStartTimeChange}
        KeyboardButtonProps={{
            'aria-label': 'change time',
        }}
    
        />
        </MuiPickersUtilsProvider>  */}
        </Grid>
        <Grid item xs={6} sm={6}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDateTimePicker
                  value={this.props.towEndTimeFilter}
                  onChange={this.handleDispatchEndTimeChange}
                  label="Created End Date"
                  
                  format="yyyy/MM/dd hh:mm a"
                />
            </MuiPickersUtilsProvider>
        {/*
            <MuiPickersUtilsProvider  utils={DateFnsUtils} >
            <TimePicker
        margin="normal"
        id="time-picker"
        label="Dispatch End Time"
        value={this.state.dispatchEndTime}
        onChange={this.handleDispatchEndTimeChange}
        KeyboardButtonProps={{
            'aria-label': 'change time',
        }}
    
        />
        </MuiPickersUtilsProvider>  */}
        </Grid>
    
        <Grid item xs={6} sm={6}>
            {/*} <TextField
        id="datetime-local"
        label="Next appointment"
        type="datetime-local"
        defaultValue="2017-05-24T10:30"
        className={classes.textField}
        InputLabelProps={{
            shrink: true,
        }}
        />  */}
        
            </Grid>
        <Grid item xs={6} sm={6}>
        
            <Button variant="contained" color="primary" className={classes.button}   onClick={(event) => this.handleLast24Hours(event)} >
            Last 24 Hours
            </Button>
            {/* we do not need status on teh tow jobs
                    <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-helper">Status</InputLabel>
                    <Select
                value={this.props.towStatusFilter}
                onChange={this.handleFilterStatusChange}
                inputProps={{
                    name: 'age',
                        id: 'age-helper',
                }}
            >
            
                {this.statusSelectList}
        
            </Select>
            
            </FormControl>
            */}
        </Grid>
    
        <Grid item xs={3} sm={3}>
            {/*} <TextField
            id="datetime-local"
            label="Next appointment"
            type="datetime-local"
            defaultValue="2017-05-24T10:30"
            className={classes.textField}
            InputLabelProps={{
                shrink: true,
            }}
            />  */}

        </Grid>
        
        </Grid>
        </div>
    )
    
    }
    
    handleLast24Hours () {
        let { setTowEndTimeFilter,setTowStartTimeFilter } = this.props;
        var currentDate = new Date();
        var yesterday= currentDate.getTime()-(24*60*60*1000);
        var yesterdayDate = new Date(yesterday);
        setTowEndTimeFilter(currentDate);
        setTowStartTimeFilter(yesterdayDate);
    
    }
    
    
    handleFilterStatusChange(event) {
        let { setTowStatusFilter } = this.props;
        setTowStatusFilter(event.target.value);
        //this.setState({filterStatus:event.target.value});
    };
    
    handleDispatchStartTimeChange(event) {
        let { setTowStartTimeFilter } = this.props;
        setTowStartTimeFilter(event);
        //this.setState({dispatchStartTime:event});
    }
    
    
    handleDispatchEndTimeChange(event) {
        let { setTowEndTimeFilter } = this.props;
        setTowEndTimeFilter(event);
        //this.setState({dispatchEndTime:event});
    }

    render() {
        //const classes = useStyles();

        const {classes} = this.props;
        //const theme = useTheme;
        const theme = createMuiTheme({
            //direction:'rtl'
        });

        let editFrameSize=7;
        let listFrameSize=5;
        
        if(this.state.showEditScreen == false){
            editFrameSize=0;
            listFrameSize=12;
        }else{
            
            editFrameSize=7;
            listFrameSize=5;
        }
        this.parkingIncidentCardList = this.getListOfTowJobs();
        let filterBoxes =  this.renderFilterCheckBoxes();

        return (
            <React.Fragment>
            <Grid container spacing={24}>
          { (this.state.showEditScreen) && (
                <Grid item xs={editFrameSize} sm={editFrameSize}>
                {/* < div className = {classes.root} > */}
                        {(this.state.editMode == true)&& (
                        <PropertyManagerTowForm  onEdit={this.editRecord}   onRefreshList={this.loadParkingIncidentData}  passedTowJob={this.state.passingTowJob} selectedCompany={this.state.selectedCompanyInHere}></PropertyManagerTowForm>
                            )}
                        {(this.state.vehicleOwnerMode == true)&& (
                        <ParkingTextVehicleOwner passedTowJob={this.state.passingTowJob}></ParkingTextVehicleOwner>
                        )}
                        {(this.state.towAgentMode == true)&& (
                        <TextTowAgent passedTowJob={this.state.passingTowJob}></TextTowAgent>
                        )}
                        {(this.state.showPictureMode == true)&& (
                        <ShowPictures passedTowJob={this.state.passingTowJob}></ShowPictures>
                        )}

                        {/*
                        < ExpansionPanel >
                        < ExpansionPanelSummary expandIcon = { < ExpandMoreIcon / > } aria-controls = "panel2a-content" id = "panel2a-header" >
                            < Typography className = {classes.heading} > Faxed Police Department < /Typography>
                        < /ExpansionPanelSummary>
                        < ExpansionPanelDetails >
                        < Typography >
                                Police Faxed Information
                        < /Typography>
                        < /ExpansionPanelDetails>
                        < /ExpansionPanel>
                        */}



                    {/*< /div> */}


                </Grid>
                )}
               
                
                
                <Grid item xs={listFrameSize} sm={listFrameSize}  >
                            <Tooltip title="Filter" aria-label="Filter">
                                <div>
                                <Grid container spacing={24}>
                                <Grid item xs={3} sm={3}>
                                          { (this.state.showEditScreen == true) && (
                                         
                                          <Button variant="contained" color="primary" style={{fontSize:10, marginBottom:10, marginRight:40}}  onClick={this.HideOrShowList} className={classes.button}  >
                                          Hide Edit
                                          </Button>
                                          
                                    )}
                                        { (this.state.showEditScreen == false) && (
                                        
                                          <Button variant="contained" color="primary" style={{fontSize:10, marginBottom:10, marginRight:40}} onClick={this.HideOrShowList} className={classes.button}  >
                                          Show Edit
                                          </Button>
                                          
                                        )}
                                    </Grid>
                                    
                                    <Grid item xs={2} sm={2}>
                                                <IconButton  color="primary" aria-label="edit" className={classes.margin}  onClick={()=>this.handleClickShowEmailSelect()}>
                                                {((!  ((this.props.towVinFilter.length != 0)|| (this.props.towYearFilter.length != 0)|| (this.props.towColorFilter.length != 0) ||
                                                    (this.props.towMakeFilter.length != 0) ||
                                                    (this.props.towPlateFilter.length != 0) ||
                                                    (this.props.towModelFilter.length != 0) ||
                                                    (this.props.towStartTimeFilter!=null )||
                                                    (this.props.towStatusFilter.length!= 0)||
                                                    (this.props.towEndTimeFilter!= null)   ))) && (<SearchIcon fontSize="large"  />)}
                                                
                                                {(  (((this.props.towVinFilter.length != 0) || (this.props.towYearFilter.length != 0) ||(this.props.towColorFilter.length != 0) ||
                                                    (this.props.towMakeFilter.length != 0) ||
                                                    (this.props.towPlateFilter.length != 0) ||
                                                    (this.props.towModelFilter.length != 0) ||
                                                    (this.props.towStartTimeFilter!= null)||
                                                    (this.props.towStatusFilter.length!= 0)||
                                                    (this.props.towEndTimeFilter!= null)  )  )) && (<FindReplaceIcon fontSize="large"  />)}
                                                </IconButton>
                                    </Grid>
                                    
                                    <Grid item xs={5} sm={5}>
                                                    <Typography variant="h6" color='primary'>
                                                        {this.props.parkingincidentsArray.length} Parking Incidents
                                                    </Typography>
                                    </Grid>
                                    <Grid item xs={2} sm={2}>
                                        <Button variant="contained" color="primary" style={{fontSize:10, marginBottom:10}} onClick={this.refresh} className={classes.button}  >
                                            Refresh List
                                        </Button>
                                    </Grid>
                                </Grid>
                                </div>
                            </Tooltip>
            
            
                            <Grid item xs={12} sm={12}  style={{fontSize:10, marginLeft:10}}>
                                <GridList cellHeight={100} className={classes.gridList}>
                                { this.parkingIncidentCardList}
                                </GridList>
                            </Grid>
                </Grid>
        
        
        
        
                    <Dialog
                open={this.state.showEmailSelectDialog}
                onClose={()=>{this.handleClickShowEmailSelectClose(true)}}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                    >
                    <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    Tow Notice Filters
                </DialogTitle>
                <DialogContent>
                {/*
                <DialogContentText>
                Please select the filters
                </DialogContentText>
                */}
                {filterBoxes}
            </DialogContent>
                <DialogActions>
               
                    <Button onClick={this.applyFilters} color="primary">
                    Apply Filters
                </Button>
                <Button onClick={this.clearFilters} color="secondary">
                    Clear filters
                </Button>
                <Button autoFocus onClick={()=>{this.handleClickShowEmailSelectClose(true)}} color="secondary">
                    Cancel
                    </Button>
                </DialogActions>
                </Dialog>
    
    
    
            </Grid>
            </React.Fragment>
    );
    }
    
   

}

PropertyManagerTowInfo.propTypes = {
    classes: PropTypes.object.isRequired,
};

/* <Typography variant="h6" gutterBottom>
                        There are {this.props.parkingincidentsArray.length}  Tow Jobs  in this list.
                    </Typography>*/

const mapStateToProps = (state) => {
    return {
        //parkingincidentsArray: state.towjob.parkingincidentsArray,
        parkingincidentsArray: state.parkingincident.parkingincidentsArray,
        selectedCompany:state.company.selectedCompany,
        towStatusFilter:state.towjob.towStatusFilter,
        towMakeFilter:state.towjob.towMakeFilter,
        towVinFilter:state.towjob.towVinFilter,
        towPlateFilter:state.towjob.towPlateFilter,
        towModelFilter:state.towjob.towModelFilter,
        towStartTimeFilter:state.towjob.towStartTimeFilter,
        towEndTimeFilter:state.towjob.towEndTimeFilter,
        towColorFilter:state.towjob.towColorFilter,
        towYearFilter:state.towjob.towYearFilter,
        errorCMsg:state.companyproperty.errorCMsg,
    };
};


const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        loadParkingIncidentsData:loadParkingIncidentsData,
        loadParkingIncidentsDataWithFilter:loadParkingIncidentsDataWithFilter,
        setParkingIncidentStatusFilter:setParkingIncidentStatusFilter,
        setParkingIncidentVinFilter:setParkingIncidentVinFilter,
        setParkingIncidentPlateFilter:setParkingIncidentPlateFilter,
        setParkingIncidentStartTimeFilter:setParkingIncidentStartTimeFilter,
        setParkingIncidentEndTimeFilter:setParkingIncidentEndTimeFilter,
        setParkingIncidentModelFilter:setParkingIncidentModelFilter,
        setParkingIncidentMakeFilter:setParkingIncidentMakeFilter,
        setParkingIncidentColorFilter:setParkingIncidentColorFilter,
        setParkingIncidentYearFilter:setParkingIncidentYearFilter,
        clearParkingIncidentAllFilters:clearParkingIncidentAllFilters,

    }, dispatch);
};

//export default (withStyles(useStyles)(TowInfo));
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PropertyManagerTowInfo));
